<div class="dialog-title" mat-dialog-title>
    <cerrix-title
        style="flex: 1"
        size="large"
        [editable]="false"
        [dataUiid]="'incident-workflow-change-dialog'"
        [value]="dialogData.title"
    ></cerrix-title>
    <button
        [attr.data-uiid]="'incident-workflow-change-dialog-close-button'"
        mat-icon-button
        mat-dialog-close
    >
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    @if (dialogData.infoText) {
        <div class="info-text">{{ dialogData.infoText }}</div>
    }

    <div>
        <cerrix-field-wrapper [required]="true" label="Comment" type="secondary">
            <cerrix-textarea
                [formControl]="commentForm"
                [dataUiid]="'incident-workflow-change-comment-input'"
            ></cerrix-textarea>
        </cerrix-field-wrapper>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    @if (dialogData.showCancelBtn) {
        <cerrix-button
            [dataUiid]="'incident-workflow-change-cancel-button'"
            color="accent"
            mat-dialog-close
            >Cancel</cerrix-button
        >
    }

    <cerrix-button
        [dataUiid]="'incident-workflow-change-apply-button'"
        [color]="dialogData.btnColor"
        (click)="onClick()"
        >{{ dialogData.btnText }}</cerrix-button
    >
</mat-dialog-actions>
